export default "/ad.jpg"